import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { default as MListItem } from '@material-ui/core/ListItem';
import { Grid } from '@material-ui/core';

var styles = function styles(theme) {
  return {
    root: {
      width: '100%',
      '&:hover': {
        backgroundColor: '#FDF6ED'
      },
      color: theme.palette.primary.main,
      '&$selected': {
        backgroundColor: '#FDF6ED !important'
      },
      '&:focus': {
        backgroundColor: 'transparent'
      }
    },
    selected: {},
    focusVisible: {
      backgroundColor: 'blue'
    }
  };
};

var ListItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ListItem, _React$Component);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(ListItem).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          children = _props.children,
          focusVisible = _props.focusVisible,
          spaced = _props.spaced,
          other = _objectWithoutProperties(_props, ['classes', 'children', 'focusVisible', 'spaced']);

      return React.createElement(MListItem, _extends({}, other, {
        classes: _extends({
          root: classes.root,
          selected: classes.selected
        }, focusVisible ? {
          focusVisible: classes.focusVisible
        } : {})
      }), spaced && React.createElement(Grid, {
        container: true,
        justify: 'space-between'
      }, children.map(function (item, idx) {
        return React.createElement(Grid, {
          item: true,
          key: 'children-' + idx
        }, item);
      })), !spaced && children);
    }
  }]);

  return ListItem;
}(React.Component);

export default withStyles(styles)(ListItem);